import FinanceSerializer from './base';

export default class Debtor extends FinanceSerializer {
  normalize(modelClass, payload) {
    // Use the account ID as a unique identifier, as each account can only
    // appear in the debtors list once.
    payload.id = payload.accountId;

    // Ensure that amounts all default to 0, so we don't get NaN / undefined.
    let defaults = {
      invoiceDebits: 0,
      donationDebits: 0,
      invoiceCredits: 0,
      donationCredits: 0,
      pia: 0,
      totalBalance: 0,
      debtBalance: 0,
    };
    let keys = Object.keys(defaults);
    Object.assign(defaults, payload);
    Object.assign(payload, defaults);

    // Convert amounts from cents to dollars.
    keys.forEach((key) => {
      payload[key] = (payload[key] / 100).toFixed(2);
    });

    return super.normalize(...arguments);
  }
}
